import type { FC } from "react";

interface SummaryFormatterProps {
  text: string;
}

const FILE_EXTENSIONS = "ts|tsx|js|jsx|json|md|yml|yaml|css|html|sh|py";
// Matches file paths with optional :line or :start-end line ranges
const FILE_PATH_SOURCE = `[a-zA-Z0-9_\\-./\\\\]+\\.(?:${FILE_EXTENSIONS})(?::\\d+(?:-\\d+)?)?`;

// Captures paths with common extensions, optionally followed by :lineNumber
const FILE_PATH_SPLITTER = new RegExp(`(${FILE_PATH_SOURCE})`, "g");
const FILE_PATH_MATCHER = new RegExp(`^${FILE_PATH_SOURCE}$`);

const renderBacktickedContent = (text: string, baseKey: number) => {
  const parts = text.split(/(`[^`]+`)/g);
  return (
    <span key={baseKey}>
      {parts.map((part, index) => {
        if (part.startsWith("`") && part.endsWith("`")) {
          return (
            <code
              key={`${baseKey}-${index}`}
              className="mx-0.5 rounded bg-gray-100 px-1 py-0.5 font-mono text-xs text-gray-800 dark:bg-white/10 dark:text-gray-200"
            >
              {part.slice(1, -1)}
            </code>
          );
        }
        return <span key={`${baseKey}-${index}`}>{part}</span>;
      })}
    </span>
  );
};

export const SummaryFormatter: FC<SummaryFormatterProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  const parts = text.split(FILE_PATH_SPLITTER);

  return (
    <span className="leading-relaxed">
      {parts.map((part, index) => {
        if (FILE_PATH_MATCHER.test(part)) {
          return (
            <code
              key={index}
              className="mx-0.5 break-all rounded bg-gray-100 px-1.5 py-0.5 font-mono text-xs text-emerald-700 dark:bg-white/10 dark:text-emerald-400"
            >
              {part}
            </code>
          );
        }

        if (part.includes("`")) {
          return renderBacktickedContent(part, index);
        }

        return <span key={index}>{part}</span>;
      })}
    </span>
  );
};
